import React from 'react'
import { Button, CircularProgress, Typography } from '@mui/material'

// Presentational only — the login popup + result handling live in indexApp
// (loginWithEquinor), which drives `loading` and `error` through props.
const EquinorLoginButton = ({ onLogin, loading, error }) => {
  return loading ? (
    <CircularProgress size={28} />
  ) : (
    <>
      <Button
        variant="outlined"
        fullWidth
        onClick={onLogin}
        style={{ marginBottom: 12 }}
      >
        Sign in with Equinor
      </Button>
      {error && (
        <Typography
          variant="body2"
          color="error"
          style={{ marginBottom: 12, textAlign: 'center' }}
        >
          {error}
        </Typography>
      )}
    </>
  )
}

export default EquinorLoginButton
